module.exports = __webpack_public_path__ + "media/theme/4 open-b283eb64.png";